import { render, staticRenderFns } from "./TradingView.vue?vue&type=template&id=07c565a6&scoped=true"
import script from "./TradingView.vue?vue&type=script&lang=js"
export * from "./TradingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c565a6",
  null
  
)

export default component.exports